export const SENTRY_DSN = 'https://a5e1ea4bc2b54f9281d0dcd9db348b89@o458014.ingest.sentry.io/4504768309493760';
// access limited to motional.cc, prd.motional.cc, and com.motional.cc.
// To access on localhost, add the VITE_GOOGLE_ANALYTICS_KEY key to your .env file
export const GOOGLE_ANALYTICS_KEY__PRD = 'G-3PMZNSRYY3';
export const GOOGLE_ANALYTICS_KEY__COM = 'G-7C7NJEQWYY';
// access limited to motional.cc.
// To access on localhost, add the VITE_MAPBOX_KEY key to your .env file
export const MAPBOX_KEY = 'pk.eyJ1IjoibW90aW9uYWwiLCJhIjoiY2w5ZTEzamc5MGNjbjN2cDlvMmM1ZmU3byJ9.V8YU90f9-Y4n6zkvDUxxCA';
//# sourceMappingURL=keys.js.map